export const SINCH_SMS_REGIONS = ['eu', 'us', 'au', 'br', 'ca'];
const SINCH_SMS_REGION_SET = new Set(SINCH_SMS_REGIONS);
export function assertAllowedSinchSmsRegion(region) {
    const normalized = (region ?? 'eu').trim().toLowerCase();
    if (!normalized || !SINCH_SMS_REGION_SET.has(normalized)) {
        throw new Error(`Invalid Sinch region. Allowed regions: ${SINCH_SMS_REGIONS.join(', ')}.`);
    }
    return normalized;
}
//# sourceMappingURL=sinch-sms-regions.js.map